import util from '@/libs/util'
import api from '@/config/api'
import {STORE_USER_MUTATION_TYPES} from '../../libs/constants'

const user = {
  state: {
    user: null,
    token: util.token(),
    role: {}
  },
  mutations: {
    [STORE_USER_MUTATION_TYPES.RESET_USER_STATE] (state) { // reset user state
      state.user = null
      state.role = {}
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    GET_USER: (state) => {
      return state.user
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ROLE: (state, role) => {
      state.role = role
    }
  },
  actions: {
    // 获取用户信息
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        if (commit('GET_USER')) {
          resolve(commit('GET_USER'))
        } else {
          api.queryUserInfo().then(response => {
            if (response.data.data) {
              const data = response.data.data
              commit('SET_ROLE', data.role)
              commit('SET_USER', data)
              util.userRoleTypeCode(data.role.roleType.code)
              resolve(response.data.data)
            } else {
              resolve(response)
            }
          }).catch(error => {
            reject(error)
          })
        }
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js